import { graphql, useStaticQuery } from 'gatsby';
import { AllPackages, ValidContracts } from './ProductDefinitions';
import React from 'react';

const GetAllProducts = (contract, userType = null) => {
  const sanitizedContract = sanitizeContractName(contract);
  const result = contract
    ? AllProducts.filter((product) => product.contract === sanitizedContract)
    : AllProducts;

  const pricingData = getPricingData();
  const productNodes = pricingData?.allProduct?.nodes;

  if (productNodes) {
    result.forEach((product) => {
      updateProduct(product, productNodes, null, userType);
    });
  }

  return result;
};

const GetAllPackages = (contract, userType = null) => {
  const sanitizedContract = sanitizeContractName(contract);
  const result = AllPackages.filter(
    (product) => product.contract === sanitizedContract,
  );

  const pricingData = getPricingData();
  const packageNodes = pricingData?.allProduct?.nodes;
  if (packageNodes) {
    result.forEach((product) => {
      updateProduct(product, packageNodes, product.bundleCode, userType);
    });
  }
  return result;
};

const GetProductByProductCode = (productCode, userType = null) => {
  let product = AllProducts.find((prod) => prod.productCode == productCode);
  const pricingData = getPricingData();
  const productNodes = pricingData?.allProduct?.nodes;

  if (productNodes) {
    updateProduct(product, productNodes, null, userType);
  }

  return product;
};

const getPricingData = () =>
  useStaticQuery(graphql`
    {
      allProduct {
        nodes {
          productCode
          catalogPackagePrice
          catalogInstallPrice
          regionalPromo
          userType
          bundleCode
        }
      }
    }
  `);

const updateProduct = (product, productNodes, bundleCode, userType) => {
  const normalizedBundleCode = bundleCode ?? null;
  const normalizedUserType = userType ? userType.toLowerCase() : null;
  const productNode = productNodes.find(
    (node) =>
      node.productCode === product.productCode &&
      !node.regionalPromo &&
      node.userType?.toLowerCase() === normalizedUserType &&
      node.bundleCode === normalizedBundleCode,
  );

  if (productNode) {
    product.price = productNode.catalogPackagePrice;
    product.installationFee = productNode.catalogInstallPrice;
  }
};

const sanitizeContractName = (value) =>
  value && ValidContracts.some((contract) => contract.id === value)
    ? value
    : ValidContracts[0].id;

const getContractDetails = (contract) => {
  const sanitizedContract = sanitizeContractName(contract);
  return ValidContracts.find((contract) => contract.id === sanitizedContract);
};
const getRoundedNumber = (number) => {
  return number % 1 != 0 ? number?.toFixed(2) : number;
};

const AllProducts = [
  {
    name: 'Lit1000',
    speed: '1Gb',
    price: 65,
    productCode: 'O-LIT-FIBRE-1000',
    contract: '12Months',
  },
  {
    name: 'Lit500',
    speed: '500Mb',
    price: 45,
    productCode: 'O-LIT-FIBRE-500',
    contract: '12Months',
  },
  {
    name: 'Lit100',
    speed: '100Mb',
    price: 30,
    productCode: 'O-LIT-FIBRE-100',
    contract: '12Months',
  },

  // 18 Month versions
  {
    name: 'Lit1000',
    speed: '1Gb',
    price: 65,
    productCode: 'O-LIT-FIBRE-1000-18M',
    contract: '18Months',
  },
  {
    name: 'Lit500',
    speed: '500Mb',
    price: 45,
    productCode: 'O-LIT-FIBRE-500-18M',
    contract: '18Months',
  },
  {
    name: 'Lit100',
    speed: '100Mb',
    price: 30,
    productCode: 'O-LIT-FIBRE-100-18M',
    contract: '18Months',
  },

  // 24 Month
  {
    name: 'Lit1000',
    speed: '1Gb',
    price: 65,
    productCode: 'O-LIT-FIBRE-1000-24M',
    contract: '24Months',
  },
  {
    name: 'Lit500',
    speed: '500Mb',
    price: 45,
    productCode: 'O-LIT-FIBRE-500-24M',
    contract: '24Months',
  },
  {
    name: 'Lit100',
    speed: '100Mb',
    price: 30,
    productCode: 'O-LIT-FIBRE-100-24M',
    contract: '24Months',
  },

  // business 12 months
  {
    name: 'LitSMB',
    speed: '500Mb',
    //ex VAT
    price: 65.95,
    //inc VAT
    vatPrice: 79.14,
    productCode: 'O-LIT-BIZ-500-12M',
    contract: '12Months',
    internal: true,
  },
  {
    name: 'LitSME',
    speed: '1GB',
    //ex VAT
    price: 229.95,
    //inc VAT
    vatPrice: 275.94,
    productCode: 'O-LIT-BIZ-1000-12M',
    contract: '12Months',
    internal: true,
  },
  {
    name: 'LitEnterprise',
    speed: '2.4GB',
    //ex VAT
    price: 454.95,
    //inc VAT
    vatPrice: 545.94,
    productCode: 'O-LIT-BIZ-2400-12M',
    contract: '12Months',
    internal: true,
  },

  //business 24 months
  {
    name: 'LitSMB',
    speed: '500Mb',
    //ex VAT
    price: 65.95,
    //inc VAT
    vatPrice: 79.14,
    productCode: 'O-LIT-BIZ-500-24M',
    contract: '24Months',
    internal: true,
  },
  {
    name: 'LitSME',
    speed: '1GB',
    //ex VAT
    price: 229.95,
    //inc VAT
    vatPrice: 275.94,
    productCode: 'O-LIT-BIZ-1000-24M',
    contract: '24Months',
    internal: true,
  },
  {
    name: 'LitEnterprise',
    speed: '2.4GB',
    //ex VAT
    price: 454.95,
    //inc VAT
    vatPrice: 545.94,
    productCode: 'O-LIT-BIZ-2400-24M',
    contract: '24Months',
    internal: true,
  },
  //business 36 months
  {
    name: 'LitSMB',
    speed: '500Mb',
    //ex VAT
    price: 65.95,
    //inc VAT
    vatPrice: 79.14,
    productCode: 'O-LIT-BIZ-500-36M',
    contract: '36Months',
    internal: true,
  },
  {
    name: 'LitSME',
    speed: '1GB',
    //ex VAT
    price: 229.95,
    //inc VAT
    vatPrice: 275.94,
    productCode: 'O-LIT-BIZ-1000-36M',
    contract: '36Months',
    internal: true,
  },
  {
    name: 'LitEnterprise',
    speed: '2.4GB',
    //ex VAT
    price: 454.95,
    //inc VAT
    vatPrice: 545.94,
    productCode: 'O-LIT-BIZ-2400-36M',
    contract: '36Months',
    internal: true,
  },
];

export {
  GetProductByProductCode,
  sanitizeContractName,
  getContractDetails,
  getRoundedNumber,
  GetAllProducts,
  GetAllPackages,
  AllProducts,
};
